void (async () => {
  const { syncRangeInputToOutput } =
    await import("../src/components/CmsDocuments/SectionPage/components/Slider/syncRangeInputToOutput");
  syncRangeInputToOutput();
})();
